import { Link } from 'react-router-dom';

type Props = {
  greeting: string;
  homeTo?: string;
};

export function AppHeader({ greeting, homeTo = '/haircheck-returning' }: Props) {
  return (
    <header className="app-header">
      <Link className="brand" to={homeTo} aria-label="Igentify Pulse">
        <span className="brand-mark" aria-hidden="true">
          <i />
          <i />
          <i />
          <i />
          <i />
          <i />
          <i />
        </span>
        <span className="brand-wordmark">
          <span>Igentify</span>
          <span>Pulse</span>
        </span>
      </Link>
      <p className="greeting">{greeting}</p>
    </header>
  );
}
